import { motion } from "framer-motion";
import { Lightning, Cube, Pipe, Wrench, Atom, Hand } from "@phosphor-icons/react";

const CATEGORIES = [
  { name: "Sheet Metal Laser Cutting", filter: "Dual Table Cutting", icon: Lightning },
  { name: "H-Beam Laser Cutting", filter: "H-Beam Cutting", icon: Cube },
  { name: "Laser Tube Cutting", filter: "Tube Cutting", icon: Pipe },
  { name: "Laser Welding", filter: "Laser Welding", icon: Wrench },
  { name: "3D Laser Cutting", filter: "3D 5-Axis Cutting", icon: Atom },
  { name: "Handheld Laser Welding & Cleaning", filter: "Laser Welding", icon: Hand },
];

export default function Categories({ onSelect }) {
  return (
    <section id="categories" data-testid="categories-section" className="bg-gradient-to-r from-navy via-[#3B2E8C] to-[#6B2A7A]">
      <div className="mx-auto grid max-w-7xl grid-cols-2 gap-y-8 px-4 py-10 sm:grid-cols-3 sm:px-8 lg:grid-cols-6">
        {CATEGORIES.map((c, i) => (
          <motion.button
            key={c.name}
            data-testid={`category-card-${i}`}
            onClick={() => onSelect(c.filter)}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.4, delay: i * 0.06 }}
            className="group flex flex-col items-center gap-3 text-center"
          >
            <c.icon size={44} weight="thin" className="text-white transition-transform duration-200 group-hover:-translate-y-1 group-hover:text-white/80" />
            <span className="text-[13px] font-medium leading-snug text-white transition-colors group-hover:text-white/80">{c.name}</span>
          </motion.button>
        ))}
      </div>
    </section>
  );
}
